var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.125,
    height: 110.839,
    viewBox: "0 0 79.125 110.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -10.229,
    x2: -10.229,
    y1: 13.597,
    y2: 14.597,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#d1d3d4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -9.516,
    x2: -9.516,
    y1: 14.078,
    y2: 15.078,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -5.39,
    x2: -4.39,
    y1: 6.703,
    y2: 6.703,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -4.964,
    x2: -3.964,
    y1: 30.297,
    y2: 30.297,
    xlinkHref: "#b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "css 3",
    transform: "translate(-226.336 -216.265)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2062af",
    d: "M173.353,207.29l-32.144,8.655-32.145-8.655-7.418-80.361h79.125Z",
    "data-name": "Path 246",
    transform: "translate(124.69 111.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c9cd7",
    d: "M269.289,154.511v75.6l.073.02,26.013-7,6-68.619Z",
    "data-name": "Path 247",
    transform: "translate(-3.391 90.087)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.041,44.47V39.687h6.978V34.453H169.807V49.246h12.212V44.47Zm19.532-4.783h4.879V34.453H187.238v5.234c1.634,1.634,2.486,2.416,4.849,4.779-1.381,0-4.849,0-4.849,0v4.775h12.213V44.47Zm17.31,0h4.879V34.453H204.548v5.234c1.634,1.634,2.487,2.416,4.85,4.779-1.381,0-4.85,0-4.85,0v4.775h12.214V44.47Z",
    "data-name": "Path 248",
    transform: "translate(72.614 181.812)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M194.685,206.429l-23.007,9.582.763,9.487,22.244-9.511,23.662-10.116.981-9.7-24.643,10.263Z",
    "data-name": "Path 249",
    transform: "translate(71.184 58.262)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M171.677,249.238l.763,9.487,22.244-9.511v-9.558Z",
    "data-name": "Path 250",
    transform: "translate(71.185 25.035)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M293.811,196.167,269.168,206.43v9.558l23.662-10.116Z",
    "data-name": "Path 251",
    transform: "translate(-3.299 58.261)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M171.827,280.258l.763,9.487,34.13.109-.763,12.649-11.231,3.162-10.8-2.726-.654-7.851H173.244l1.309,15.156,20.282,6,20.172-5.888,2.617-30.094Z",
    "data-name": "Path 252",
    transform: "translate(71.071 -5.985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.685,280.258H171.678l.763,9.487,22.244.071Zm0,25.376-.109.03-10.795-2.726-.654-7.851H173.1l1.308,15.156,20.281,6Z",
    "data-name": "Path 253",
    opacity: 0.05,
    transform: "translate(71.184 -5.985)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M162.9,196.167h49.721l-.981,9.7H164.1Z",
    "data-name": "Path 254",
    transform: "translate(77.893 58.261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.977,196.167H162.9l1.2,9.7h23.879Z",
    "data-name": "Path 255",
    opacity: 0.05,
    transform: "translate(77.892 58.261)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.dc06e3f2d1fa79f8e67248eb5c1db40d.svg";
export { ForwardRef as ReactComponent };